import { Card, Checkbox, Form, Input, Typography } from "antd";
import Inputmask from "inputmask";
import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import "../../App.less";
import { leadWSAPI, tracerAPI } from "../../Configs/API";
import calculatorForm from "../../Configs/JSON/calculatorForm.json";
import FormStore from "../../Configs/Store/forms";
import AppStore from "../../Configs/Store/index";
import {
  ageValidation,
  emailValidation,
  phoneValidation,
} from "../../Configs/Validator/FormValidations";
import {
  getCookieBoi,
  getStorageBoi,
  getReactStorageBoi,
  isJson,
  capitalize,
  BlowFishReact,
  maskData,
  maskMobile,
  maskEmail,
  suitablityUserInput,
  HideLandingLoader,
  InjectCustomAppForm,
  addCommas,
  ExistingCustToaster,
  GenerateQData,
  NDNC_DISCLAIMER_TRUNCATED,
  NDNC_DISCLAIMER_FULL,
  ExistingCustomer,
  maskDetail,
} from "../Common/CommonFunctions";
import GenericButton from "../Common/GenericButton";
import IconTooltip from "../Common/IconTooltip";
import RadioGroup from "../Common/RadioGroup";
import { undefinedFlag, UserInput } from "../QuoteScreen/QuoteAPI";
import AI_Modal from "./AI_Modal";
import MobileModal from "./MobileModal";
import { DataLayerFn } from "../../Configs/API";
import DOMPurify from "dompurify";
import { toJS } from "mobx";
import Dropdown_Icon from "../../assets/Dropdown_Icon.svg";
import { isOldJourney } from "@ipru-common/utils/CommonFunctions";
const { Text } = Typography;

const cityArr = [
  "Mumbai",
  "Delhi",
  "Bangalore",
  "Hyderabad",
  "Ahmedabad",
  "Chennai",
  "Kolkata",
  "Surat",
  "Pune",
  "Jaipur",
  "Visakhapatnam",
  "Kanpur",
  "Nagpur",
  "Lucknow",
  "Thane",
  "Bhopal",
  "Indore",
  "Pimpri",
  "Chinchwad",
  "Patna",
  "Vadodara",
  "Ghaziabad",
  "Ludhiana",
  "Agra",
  "Nashik",
  "Faridabad",
  "Meerut",
  "Rajkot",
  "Kalyan",
  "Dombivli",
  "Vasai",
  "Virar",
  "Varanasi",
  "Srinagar",
  "Aurangabad",
  "Dhanbad",
  "Amritsar",
  "Navi Mumbai",
  "Allahabad",
  "Howrah",
  "Ranchi",
  "Gwalior",
  "Jabalpur",
  "Coimbatore",
  "Vijayawada",
  "Jodhpur",
  "Madurai",
  "Raipur",
  "Chandigarh",
  "Guntur",
  "Guwahati",
  "Solapur",
  "Hubli",
  "Dharwad",
  "Tiruchirappalli",
  "Bareilly",
  "Moradabad",
  "Mysore",
  "Tiruppur",
  "Gurgaon",
  "Aligarh",
  "Jalandhar",
  "Bhubaneswar",
  "Salem",
  "Mira",
  "Bhayandar",
  "Warangal",
  "Jalgaon",
  "Kota",
  "Bhiwandi",
  "Saharanpur",
  "Gorakhpur",
  "Bikaner",
  "Amravati",
  "Noida",
  "Jamshedpur",
  "Bhilai",
  "Cuttack",
  "Firozabad",
  "Kochi",
  "Nellore",
  "Bhavnagar",
  "Dehradun",
  "Durgapur",
  "Asansol",
  "Rourkela",
  "Nanded",
  "Kolhapur",
  "Ajmer",
  "Akola",
  "Gulbarga",
  "Jamnagar",
  "Ujjain",
  "Loni",
  "Siliguri",
  "Jhansi",
  "Ulhasnagar",
  "Jammu",
  "Sangli",
  "Miraj",
  "Kupwad",
  "Mangalore",
  "Erode",
  "Belgaum",
  "Ambattur",
  "Tirunelveli",
  "Malegaon",
  "Gaya",
  "Thiruvananthapuram",
  "Udaipur",
  "Kakinada",
  "Davanagere",
  "Kozhikode",
  "Maheshtala",
  "Rajpur Sonarpur",
  "Rajahmundry",
  "Bokaro",
  "South Dumdum",
  "Bellary",
  "Patiala",
  "Gopalpur",
  "Agartala",
  "Bhagalpur",
  "Muzaffarnagar",
  "Bhatpara",
  "Panihati",
  "Latur",
  "Dhule",
  "Tirupati",
  "Rohtak",
  "Korba",
  "Bhilwara",
  "Berhampur",
  "Muzaffarpur",
  "Ahmednagar",
  "Mathura",
  "Kollam",
  "Avadi",
  "Kadapa",
  "Kamarhati",
  "Sambalpur",
  "Bilaspur",
  "Shahjahanpur",
  "Satara",
  "Bijapur",
  "Kurnool",
  "Rampur",
  "Shimoga",
  "Chandrapur",
  "Junagadh",
  "Thrissur",
  "Alwar",
  "Bardhaman",
  "Kulti",
  "Nizamabad",
  "Parbhani",
  "Tumkur",
  "Khammam",
  "Ozhukarai",
  "Bihar Sharif",
  "Panipat",
  "Darbhanga",
  "Bally",
  "Aizawl",
  "Dewas",
  "Ichalkaranji",
  "Karnal",
  "Bathinda",
  "Jalna",
  "Eluru",
  "Barasat",
  "Kirari Suleman Nagar",
  "Purnia",
  "Satna",
  "Mau",
  "Sonipat",
  "Farrukhabad",
  "Sagar",
  "Durg",
  "Imphal",
  "Ratlam",
  "Hapur",
  "Arrah",
  "Anantapur",
  "Karimnagar",
  "Etawah",
  "Ambarnath",
  "North Dumdum",
  "Bharatpur",
  "Begusarai",
  "New Delhi",
  "Gandhidham",
  "Baranagar",
  "Tiruvottiyur",
  "Pondicherry",
  "Sikar",
  "Thoothukudi",
  "Rewa",
  "Mirzapur",
  "Raichur",
  "Pali",
  "Ramagundam",
  "Haridwar",
  "Vijayanagaram",
  "Tenali",
  "Nagercoil",
  "Sri Ganganagar",
  "Karawal Nagar",
  "Mango",
  "Thanjavur",
  "Bulandshahr",
  "Uluberia",
  "Katni",
  "Sambhal",
  "Singrauli",
  "Nadiad",
  "Secunderabad",
  "Naihati",
  "Yamunanagar",
  "Bidhannagar",
  "Pallavaram",
  "Bidar",
  "Munger",
  "Panchkula",
  "Burhanpur",
  "Raurkela Industrial Township",
  "Kharagpur",
  "Dindigul",
  "Gandhinagar",
  "Hospet",
  "Nangloi Jat",
  "Malda",
  "Ongole",
  "Deoghar",
  "Chapra",
  "Haldia",
  "Khandwa",
  "Nandyal",
  "Morena",
  "Amroha",
  "Anand",
  "Bhind",
  "Bhalswa Jahangir Pur",
  "Madhyamgram",
  "Bhiwani",
  "Berhampore",
  "Ambala",
  "Morbi",
  "Fatehpur",
  "Raebareli",
  "Mahaboobnagar",
  "Chittoor",
  "Bhusawal",
  "Orai",
  "Bahraich",
  "Vellore",
  "Mehsana",
  "Raiganj",
  "Sirsa",
  "Danapur",
  "Serampore",
  "Sultan Pur Majra",
  "Guna",
  "Jaunpur",
  "Panvel",
  "Shivpuri",
  "Surendranagar Dudhrej",
  "Unnao",
  "Chinsurah",
  "Alappuzha",
  "Kottayam",
  "Machilipatnam",
  "Shimla",
  "Adoni",
  "Udupi",
  "Katihar",
  "Proddatur",
  "Saharsa",
  "Hindupur",
  "Sasaram",
  "Hajipur",
  "Bhimavaram",
  "Kumbakonam",
  "Dehri",
  "Madanapalle",
  "Siwan",
  "Bettiah",
  "Guntakal",
  "Srikakulam",
  "Motihari",
  "Dharmavaram",
  "Gudivada",
  "Phagwara",
  "Narasaraopet",
  "Suryapet",
  "Miryalaguda",
  "Tadipatri",
  "Karaikudi",
  "Kishanganj",
  "Jamalpur",
  "Ballia",
  "Kavali",
  "Tadepalligudem",
  "Amaravati",
  "Buxar",
  "Jehanabad",
  "Gangtok",
];
const top10Cities = [
  "Ahmedabad",
  "Bangalore",
  "Chennai",
  "Delhi",
  "Hyderabad",
  "Jaipur",
  "Kolkata",
  "Lucknow",
  "Mumbai",
  "Pune",
];

const Calculator = observer(
  ({ calcFormRef, quoteFormRef, QuoteAPI, quoteJointLife }) => {
    const [disableQData, setDisableQData] = useState(false);

    const [moberrorMsg, setMobileerrorMsg] = useState(false);
    const [cityTyped, setcityTyped] = useState("");
    const [showCityOptions, setShowCityOptions] = useState(false);
    const dobInput = useRef(null);
    const mobInput = useRef(null);
    const emailInput = useRef(null);
    const cityInput = useRef(null);
    const investField = useRef({});
    const [viewMore, setViewMore] = useState(true);
    var nudgeRangeTimeout = null;

    const allCities = [
      ...top10Cities,
      "divider",
      ...cityArr.filter((city) => !top10Cities.includes(city)).sort(),
    ];

    const filteredCity = allCities.filter((city) =>
      city.toLowerCase().startsWith(cityTyped.toLowerCase()),
    );

    useEffect(() => {
      setTimeout(async () => {
        const isAppResume = AppStore.isResumeJourney; // Priority High
        if (isAppResume) {
          //redirect old customers to old appform in resume journey
          if (isOldJourney()) {
            FormStore.setQuoteModal(true);
          } else {
            AppStore.setShowRemoteHandOverAppForm(true);
          }
          setTimeout(() => HideLandingLoader(true), 5500);
        } else {
          const isQDataAvail = await checkQDATA(); // Priority Medium
          if (!isQDataAvail) {
            const isLocalAvail = await preFillByLocalStorage(); // Priority Low
          }
        }
      }, 100);
    }, []);

    //Applying masking
    useEffect(() => {
      if (!FormStore.PiiMaskFlag) return;

      applyMask("mobileItem");
      applyMask("emailItem");
    }, [FormStore.PiiMaskFlag]);

    const applyMask = async (fieldName) => {
      const val = calcFormRef.getFieldValue(fieldName);
      if (!val || val.includes("X")) return;
      await calcFormRef.setFieldsValue({
        [fieldName]: maskDetail(val),
      });
    };

    const toggleViewMore = () => {
      setViewMore((prev) => !prev);
    };

    const sharpQData = (name, query) => {
      if (!query) query = window.location.search;
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(query);

      if (results === null) return "";
      else return decodeURIComponent(results[1]);
    };

    const checkQDATA = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      var qDataTest = params["qdata"];
      console.log("Roshan Before Qdata", params["qdata"]);
      if (qDataTest !== "" && qDataTest !== undefined && qDataTest !== null) {
        var decryptQdata = await sharpQData("qdata");
        var qdata = await BlowFishReact(false, "", decryptQdata);
        console.log("Roshan QData", JSON.parse(qdata));
        if (qdata !== undefined) {
          if (isJson(qdata)) {
            var tempObj_1 = JSON.parse(qdata);
            preFillData(tempObj_1, true);
          } else {
            qdata = await BlowFishReact(false, "DIGI", decryptQdata);
            var tempObj_2 = JSON.parse(qdata);
            preFillData(tempObj_2, true, true);
            if (params["Step"] !== "true") {
              setDisableQData(true);
            }
          }
        }
        return true;
      } else {
        return false;
      }
    };

    //Roshan

    const mapIncomeJSON = [
      { Savings: "250000", Protection: "100000" },
      { Savings: "250000", Protection: "350000" },
      { Savings: "625000", Protection: "650000" },
      { Savings: "875000", Protection: "900000" },
      { Savings: "1250000", Protection: "1500000" },
      { Savings: "1750000", Protection: "1500000" },
      { Savings: "2000000", Protection: "2000000" },
    ];

    //Roshan
    const mapIncome = (productCat, amount) => {
      if (productCat == "Savings") {
        var item = mapIncomeJSON.find((val) => val["Savings"] == amount);
        return item["Protection"];
      }
      if (productCat == "Protection") {
        var item = mapIncomeJSON.find((val) => val["Protection"] == amount);
        return item["Savings"];
      }
    };

    const preFillByLocalStorage = async () => {
      var cookieDob = await getCookieBoi("dob");
      if (typeof cookieDob === "string") {
        window.UserInput["dob"] = cookieDob;

        setTimeout(async () => {
          var cookieProdId = await getCookieBoi("GPPproductId");
          var localData = await getReactStorageBoi("productInfoGPP");
          var localDataCommon = await getReactStorageBoi("productInfoCommon"); //temp
          console.log("getReactStorage Product:", localData);
          console.log("type of ", typeof localDataCommon);
          if (
            Object.keys(localDataCommon).length > 0 &&
            typeof localDataCommon == "object"
          ) {
            console.log("If", localDataCommon);
            setTimeout(preFillData, 100, localDataCommon, false, false, true);
          } else {
            console.info(
              "preFillByLocalStorage :",
              localData,
              cookieProdId,
              cookieDob,
            );
            var prodId_1 = "I13";
            var prodId_2 = "I14";
            var I13Storage = { ...localData };
            if (cookieProdId && localData) {
              if (cookieProdId === prodId_1 || cookieProdId === prodId_2) {
                if (cookieDob === localData["dob"]) {
                  setTimeout(preFillData, 100, I13Storage, false, false, false);
                }
              }
              return true;
            }
          }
          // If no data in localDataCommon. typeof localDataCommon object
        }, 1500);
      }
      return false;
    };
    // 5 ot of 5 fields
    const preFillLandingPageData = async (
      tempObj,
      QDataFlag,
      maskFlag = false,
    ) => {
      var value;
      if (tempObj["Maritalstatus"] !== undefined) {
        value = tempObj["Maritalstatus"];
        FormStore.setCalcMarital(value);
        calcFormRef.setFieldsValue({ maritalStatus: value });
        console.info("Maritual Status", value);
        UserInput("Maritalstatus", "", value);
      }
      //The New QData for Martial Status
      if (tempObj["martialStatus"]) {
        value = tempObj["martialStatus"];
        value =
          value === "696"
            ? "Married"
            : value === "694"
              ? "Widowed"
              : value === "695"
                ? "Divorced"
                : "Single";
        calcFormRef.setFieldsValue({ maritalStatus: value });
        FormStore.setCalcMarital(value);
        UserInput("Martialstatus", value, "", "");
      }
      if (tempObj["EmailId"] !== undefined || tempObj["Email"] !== undefined) {
        value = tempObj["EmailId"] ?? tempObj["Email"];
        FormStore.setCalcEmail(value);
        calcFormRef.setFieldsValue({
          emailItem: FormStore.PiiMaskFlag ? maskDetail(value) : value,
        });
        UserInput("EmailId", "", value);
        suitablityUserInput("EmailId", "", value);
      }
      if (
        tempObj["MobileNo"] !== undefined ||
        tempObj["Mobile"] !== undefined
      ) {
        value = tempObj["MobileNo"] ?? tempObj["Mobile"];
        FormStore.setCalcPhone(value);
        calcFormRef.setFieldsValue({
          mobileItem: FormStore.PiiMaskFlag ? maskDetail(value) : value,
        });
        UserInput("MobileNo", "", value);
        suitablityUserInput("MobileNo", "", value);
      }
      if (tempObj["dob"] !== undefined) {
        value = tempObj["dob"];
        FormStore.setCalcDob(value);
        calcFormRef.setFieldsValue({
          ageItem: maskFlag ? maskData(value) : value,
        });
        await calculateAge(value);
        UserInput("dob", "", value);
        suitablityUserInput("dob", "", value);
        UserInput("age", "", FormStore.calc_age);
        window.dataLayer_dob = true;
      }
      if (tempObj["gender"] !== undefined) {
        value = tempObj["gender"];
        var userInputVal = value;
        if (userInputVal === "Other") {
          userInputVal = "Male";
        }
        FormStore.setCalcGender(value);
        calcFormRef.setFieldsValue({ gender: value });
        UserInput("gender", "", userInputVal);
        suitablityUserInput("gender", "", value);
      }
      if (
        tempObj["suitCheckbox"] !== undefined &&
        tempObj["suitCheckbox"] !== null
      ) {
        value = tempObj["suitCheckbox"];
        FormStore.setCalcCheckTwo(value);
        calcFormRef.setFieldsValue({ suitCheckbox: value });
        // emailInput && emailInput.current && emailInput.current.value && emailInput.current.value = value;
        UserInput("suitCheckbox", "", value);
      }
      if (tempObj["NPS_Flag"] !== undefined) {
        value = tempObj["NPS_Flag"];
        var flag = value === "No" ? "N" : "Y";
        FormStore.setQuoteNPS(flag);
        calcFormRef.setFieldsValue({ calcNps: flag });
        UserInput("NPS_Flag", "", value);
      }
      console.log("tempObj[City]", tempObj["City"], tempObj);
      if (tempObj["City"] !== undefined) {
        value = tempObj["City"];
        FormStore.setCalcCity(value);
        calcFormRef.setFieldsValue({ city: value });
        setcityTyped(value);
        UserInput("City", "", value);
      }
      if (tempObj["Occupation"] !== undefined) {
        value = tempObj["Occupation"];
        FormStore.setCalcOccupation(value);
        calcFormRef.setFieldsValue({ occupation: value });
        // setcityTyped(value)
        UserInput("Occupation", "", value);
      }
    };

    const preFillQuotePageData = async (
      tempObj,
      QDataFlag,
      maskFlag = false,
    ) => {
      var value;

      if (tempObj["Premium"] !== undefined) {
        value = tempObj["Premium"];
        var reverse = tempObj["reverse"];
        if (reverse === "true") {
          FormStore.setQuoteInvest("");
          FormStore.setQuoteAnAmount(value);
        } else {
          FormStore.setQuoteInvest(Number(value));
          calcFormRef.setFieldsValue({ investmentAmount: addCommas(value) });
          // calcFormRef.setFieldsValue({ OneTimeInvestment: Number(value) });
          FormStore.setQuoteAnAmount("");
        }
        UserInput("Premium", "", value);
        UserInput("reverse", "", reverse);
      }

      if (tempObj["PaymentFrequency"] !== undefined) {
        value = tempObj["PaymentFrequency"];
        var tempValue = value === "half-yearly" ? "Half-Yearly" : value;
        tempValue = await capitalize(tempValue);
        FormStore.setQuoteAnFreq(tempValue);
        UserInput("PaymentFrequency", "", tempValue);
      }

      if (tempObj["PensionFor"] !== undefined) {
        value = tempObj["PensionFor"];
        var fullName = await undefinedFlag(tempObj["Spouse_name"], "");
        var age = await undefinedFlag(tempObj["Spouse_Age"], "");
        var relation = await undefinedFlag(tempObj["Spouse_Relation"], "");
        var dob = await undefinedFlag(tempObj["Spouse_DOB"], "");
        var gender = await undefinedFlag(tempObj["Spouse_Gender"], "Male");
        var Pension =
          value === "wantMe"
            ? "Me"
            : value === "wantMeSpouce"
              ? "Me_&_Joint_life"
              : value === "wantMenominee"
                ? "Me_&_Nominee"
                : value === "wantMeSpouceNominee"
                  ? "Me_Joint_life_&_nominee"
                  : "NPS_family_Income";
        if (value.includes("Spouce")) {
          if (fullName !== "" && relation !== "" && dob !== "") {
            FormStore.setQuotePension(Pension);
            UserInput("PensionFor", "", value);

            FormStore.setJointFullName(fullName);
            FormStore.setJointDOB(dob);
            FormStore.setJointAge(age);
            FormStore.setJointLife(relation);

            UserInput("Spouse_name", "", fullName);
            UserInput("Spouse_DOB", "", dob);
            UserInput("Spouse_Age", "", age);
            UserInput("Spouse_Gender", "", gender);
            UserInput("Spouse_Relation", "", relation);
          } else {
            var tabOne = FormStore.quote_formTab === "0";
            if (tabOne) {
              FormStore.setQuotePension("Me");
              UserInput("PensionFor", "", "wantMe");
            } else {
              FormStore.setQuotePension("Me_&_Nominee");
              UserInput("PensionFor", "", "wantMenominee");
            }
          }
        } else {
          FormStore.setQuotePension(Pension);
          UserInput("PensionFor", "", value);
        }
        console.info("Spouse :", value);
      }
      if (tempObj["PolicyTerm"] !== undefined && tempObj["PolicyTerm"] !== "") {
        value = tempObj["PolicyTerm"];
        FormStore.setQuoteRecAnFreq(Number(value));
        UserInput("PolicyTerm", "", value);
      }
    };

    const preFillSuitabilityUserInput = (
      tempObj,
      QDataFlag,
      maskFlag = false,
    ) => {
      if (tempObj["FFGoal"])
        suitablityUserInput("FFGoal", "", tempObj["FFGoal"]);

      if (tempObj["goalHorizon"])
        suitablityUserInput("goalHorizon", "", tempObj["goalHorizon"]);

      if (tempObj["lifeStage"])
        suitablityUserInput("lifeStage", "", tempObj["lifeStage"]);

      if (tempObj["insurancePortfolioHeld"])
        suitablityUserInput(
          "insurancePortfolioHeld",
          "",
          tempObj["insurancePortfolioHeld"],
        );

      if (tempObj["useTobacco"])
        suitablityUserInput("useTobacco", "", tempObj["useTobacco"]);

      if (tempObj["lifeStage"])
        suitablityUserInput("lifeStage", "", tempObj["lifeStage"]);

      if (tempObj["paymentPref"])
        suitablityUserInput("paymentPref", "", tempObj["paymentPref"]);

      if (tempObj["riskProfile"])
        suitablityUserInput("riskProfile", "", tempObj["riskProfile"]);

      if (tempObj["Page_Name"])
        suitablityUserInput("Page_Name", "", tempObj["Page_Name"]);

      if (tempObj["income"])
        suitablityUserInput("income", "", tempObj["income"]);
    };

    const preFillData = async (
      tempObj,
      QDataFlag,
      maskFlag = false,
      isGlobal = false,
    ) => {
      FormStore.setPiiMaskFlag(true);
      if (QDataFlag) {
        //if coming from Suitability, then hide Suitability Checkbox.
        console.log("QDataFlag", QDataFlag);
        FormStore.setQuoteCheckTwo(true);
        FormStore.setCalcCheckTwo(true);
        // FormStore.setSuitabilityFlag(true)
      }
      console.info("preFillData :", tempObj);

      var value;
      if (isGlobal) {
        console.log("Roshan Prefilling Landing Page Only ");
        preFillLandingPageData(tempObj, QDataFlag, maskFlag);
      } else {
        if (!FormStore.persona_Validity) {
          if (tempObj["calcType"] !== undefined) {
            value = tempObj["calcType"]["key"];
            FormStore.setCalcType(value);
            UserInput("calcType", "key", value);
            localStorage.recent_product =
              value === "GPPDA" ? "GPP_DA_dynamic" : "GPP_dynamic";
          }
          if (tempObj["productId"] !== undefined) {
            value = tempObj["productId"];
            var flag = value === "I13" ? "0" : "1";
            FormStore.setQuoteFormTab(flag);
            UserInput("productId", "", value);
          }
        }
        console.log("Roshan Prefilling Landing Page and Quote Page ");
        preFillLandingPageData(tempObj, QDataFlag, maskFlag);
        preFillQuotePageData(tempObj, QDataFlag, maskFlag);
      }
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      var suitabilty = params["suitablity"];
      if (suitabilty === "yes") {
        preFillSuitabilityUserInput(tempObj, QDataFlag, maskFlag);
      }
      // qData For Gamooga Prefil
      if (tempObj["qdata"] !== "") {
        UserInput("qdata", "", tempObj["qdata"]);
      }

      if (QDataFlag) {
        var isStepTrue =
          new URL(window.location.href).searchParams.get("Step") === "true";
        setTimeout(() => {
          if (isStepTrue) {
            calcFormRef.submit();
            HideLandingLoader();
          }
        }, 1000);
      }
    };

    const handleNoIncomeOccupation = (e) => {
      //0 Annual Income for Occupation Student and House Wife onlu if LA is major
      if (
        (FormStore.calc_occupation === "Student" ||
          FormStore.calc_occupation === "House-wife") &&
        FormStore.calc_age >= 18
      ) {
        // FormStore.setCalcAnualIncome(0)
        // calcFormRef.setFieldsValue({ annualItem: 0 })
        UserInput("AnnualIncome", "", "0");
      } else {
        //Reset Annual Income on Buy For and Occupation Change
        // FormStore.setCalcAnualIncome(null)
        // calcFormRef.setFieldsValue({ annualItem: null })
        //Default Annual Income 10 Lakh in GPP Calculator
        UserInput("AnnualIncome", "", "1000000");
      }
    };

    const toggleNps = async (e) => {
      var value = e.target.value;
      await FormStore.setQuoteNPS(value);

      if (value === "N") {
        var fieldValues = quoteFormRef.getFieldsValue(true);
        if (Object.entries(fieldValues).length > 0) {
          quoteFormRef.setFieldsValue({ Pension: "Me_&_Nominee" });
        }
        FormStore.setQuotePension("Me_&_Nominee");
        FormStore.setQuoteFormTab("1");
        UserInput("productId", "", "I14");
        UserInput("PensionFor", "", "wantMenominee");
      } else {
        var fieldValues = quoteFormRef.getFieldsValue(true);
        if (Object.entries(fieldValues).length > 0) {
          quoteFormRef.setFieldsValue({ Pension: "Me" });
        }
        FormStore.setQuotePension("Me");
        FormStore.setQuoteFormTab("0");
        UserInput("productId", "", "I13");
        UserInput("PensionFor", "", "wantMe");
      }

      var yesNo = value === "Y" ? "Yes" : "No";
      UserInput("NPS_Flag", "", yesNo);
      console.info("Calc NPS :", FormStore.quote_NPS);
      DataLayerFn(
        "NPS_Selected||Calculator-Landing page|NPS",
        FormStore,
        "",
        "",
        "",
        "",
      );
    };
    const handleEnterKey = async (e, type) => {
      if (e !== null) {
        e.currentTarget.blur();
        return true;
      }

      var InvestAmount = calcFormRef.getFieldValue("investmentAmount");

      console.info("Blur Values :", InvestAmount);

      if (type === 1 && InvestAmount !== "") {
        FormStore.setQuoteAnAmount("");
        resetInvest("investmentAmount", type);
        calcFormRef.setFields([{ name: "investmentAmount", errors: [] }]);
      }
    };
    const resetInvest = async (key, storeFlag) => {
      var rangeValue = 0;
      var investValue = calcFormRef.getFieldValue("investmentAmount");
      investValue = await formatInvest(investValue);
      investValue = Number(investValue);
      if (investValue < 500 || investValue > 100000000) {
        if (storeFlag === 1) {
          var quoteInvest = FormStore.quote_invest;
          investValue = quoteInvest === "" ? 1000000 : quoteInvest;
        }
      }

      calcFormRef.setFieldsValue({ investmentAmount: addCommas(investValue) });
      // calcFormRef.setFieldsValue({ OneTimeInvestment: investValue })
      storeFlag === 1
        ? FormStore.setQuoteInvest(investValue)
        : FormStore.setQuoteAnAmount(investValue);

      if (200000 <= investValue && investValue < 300000) {
        rangeValue = 300000;
      } else if (400000 <= investValue && investValue < 500000) {
        rangeValue = 500000;
      } else if (800000 <= investValue && investValue < 1000000) {
        rangeValue = 1000000;
      } else if (2200000 <= investValue && investValue < 2500000) {
        rangeValue = 2500000;
      } else {
        rangeValue = 0;
      }

      UserInput("Premium", "", investValue);
      UserInput("reverse", "", storeFlag === 2);
    };
    const formatInvest = (value) => {
      var newValue = value + "";
      if (newValue === undefined || newValue === null) {
        // Wont Require Mostly
        newValue = "";
      } else if (newValue.includes(",")) {
        newValue = newValue.replace(/,/g, "").replace(/\D+/g, ""); // Remove Commas, Remove Other Then Number
      } else {
        newValue = newValue.replace(/\D+/g, "");
      }

      return newValue;
    };

    const onInvestAmountChange = async (e) => {
      var newValue = e.target.value;
      console.info("onInvestAmountChange :", newValue);
      newValue = await formatInvest(newValue);
      calcFormRef.setFieldsValue({
        investmentAmount: addCommas(newValue),
      });
      var tempvalue = newValue === "" ? "" : Number(newValue);
      quoteFormRef.setFieldsValue({
        investmentAmount: addCommas(newValue),
        annuityAmount: "",
      });
      UserInput("Premium", "", tempvalue);
      FormStore.setQuoteInvest(tempvalue);
    };
    const toggleGender = async (e) => {
      var value = e.target.value;
      var userInputVal = value;
      if (userInputVal === "Other") {
        userInputVal = "Male";
      }
      await FormStore.setCalcGender(value);
      UserInput("gender", "", userInputVal);
      console.info("Gender :", FormStore.calc_gender);

      if (value === "Male" && FormStore.joint_life === "Husband") {
        FormStore.setJointLife("Wife");
        quoteJointLife.setFieldsValue({
          jointLifeSelect: "Wife",
        });
        UserInput("Spouse_Gender", "", "Female");
        UserInput("Spouse_Relation", "", "Wife");
      } else if (value === "Female" && FormStore.joint_life === "Wife") {
        FormStore.setJointLife("Husband");
        UserInput("Spouse_Gender", "", "Male");
        UserInput("Spouse_Relation", "", "Husband");
        quoteJointLife.setFieldsValue({
          jointLifeSelect: "Husband",
        });
      }
    };

    const toggleMarital = (value) => {
      value = AppStore.device === 0 ? value.target.value : value;
      FormStore.setCalcMarital(value);
      UserInput("Maritalstatus", "", value);
      console.info("Marital Status :", value);
    };
    const toggleOccupation = (value) => {
      //console.log("value",value)
      //value = AppStore.device === 0 ? value.target.value : value
      FormStore.setCalcOccupation(value);
      UserInput("Occupation", "", value);
      calcFormRef.setFieldsValue({ occupation: value });
      handleNoIncomeOccupation();
      console.info("Occupation :", value);
    };

    const removeOptions = (jsonData = calculatorForm.occupation) => {
      let newJsonData = JSON.parse(JSON.stringify(jsonData));
      if (FormStore.calc_gender !== "Female") {
        if (FormStore.calc_occupation === "House-wife") {
          FormStore.setCalcOccupation("");
          UserInput("Occupation", "", "");
          calcFormRef.resetFields(["occupation"]);
          // calcFormRef.resetFields("occupationItem")
          calcFormRef.setFieldsValue({ occupation: "" });
        }
      }
      newJsonData.options =
        FormStore.calc_gender !== "Female"
          ? jsonData.options.filter((item) => item.value !== "House-wife")
          : jsonData.options;

      return newJsonData;
    };

    const toggleMobileToolTip = (e) => {
      e.preventDefault();
      if (AppStore.device === 0) {
        FormStore.setMobileModal(true);
      }
    };

    const DateBoi = async (e) => {
      if (e !== null) {
        Inputmask("99/99/9999", {
          placeholder: "DD/MM/YYYY",
          prefillYear: false,
        }).mask(e.target);
      }
    };

    const inputWithMaskOnChange = (e) => {
      var value = e.target.value;
      calculateAge(value);
      FormStore.setCalcDob(value);
      // console.info("Age Change :", value)
    };

    const inputWithMaskOnPaste = (e) => {
      var value = e.target.value;
      calculateAge(value);
      FormStore.setCalcDob(value);
      // console.info("Age Change :", e)
    };

    const calculateAge = async (value) => {
      var min = 30;
      var max = 100;
      var flag = await ageValidation(value, min, max);
      // console.info("Age Validation :", flag)
      await FormStore.setCalcAge(flag.age);
      if (flag.valid && Math.sign(flag.age) !== -1) {
        calcFormRef.setFields([
          {
            name: "ageItem",
            errors: [],
          },
        ]);
        window.dataLayer_dob = true;
      } else if (flag.age === -1 || flag.age === -2) {
        calcFormRef.setFields([
          {
            name: "ageItem",
            errors: [flag.errorMsg],
          },
        ]);
        window.dataLayer_dob = false;
      }
      handleNoIncomeOccupation();
    };

    const phoneNumberInput = async (e) => {
      var value = e.target.value;
      if (!value) {
        setMobileerrorMsg(true);
      }
      value = value.replace(/\D/g, "");
      await calcFormRef.setFieldsValue({ mobileItem: value });
      await FormStore.setCalcPhone(value);
      UserInput("MobileNo", "", value);
      console.info("Phone Number :", FormStore.calc_phone);
    };

    const handleMobileFocus = async () => {
      if (!FormStore.PiiMaskFlag) return;
      const value = calcFormRef.getFieldValue("mobileItem");
      if (!value) return;
      try {
        await calcFormRef.validateFields(["mobileItem"]);
        await FormStore.setCalcPhone("");
        await calcFormRef.setFieldsValue({
          mobileItem: "",
        });
      } catch (err) {
        console.log("Mobile not valid, skipping clear");
      }
    };

    const handleMobileBlur = async (e) => {
      const value = e.target.value;
      if (!FormStore.PiiMaskFlag || !value) return;
      try {
        await calcFormRef.validateFields(["mobileItem"]);
        await calcFormRef.setFieldsValue({
          mobileItem: maskDetail(value),
        });
      } catch (err) {
        console.log("Mobile not valid, skipping mask");
      }
    };

    const onChangeEmailInput = async (e) => {
      var value = e.target.value;
      value = await emailValidation(value);
      value = value["email"];
      calcFormRef.setFieldsValue({ emailItem: value });
      await FormStore.setCalcEmail(value);
      UserInput("EmailId", "", value);
      console.info("Email :", value);
    };

    // const onChangeCityInput = async (e) => {
    //   var value = e.target.value
    //   //value = await emailValidation(value)
    //   value = value["email"]
    //   calcFormRef.setFieldsValue({ emailItem: value })
    //   await FormStore.setCalcEmail(value)
    //   UserInput("City", "", value)
    //   console.info("City :", value)
    // }

    const onChangeCityInput = async (e) => {
      var value = e.target.value;
      setShowCityOptions(true);
      setcityTyped(value);
      UserInput("City", "", value);
      await calcFormRef.setFieldsValue({ city: value });
      await FormStore.setCalcCity(value);
    };
    const citySelected = async (city) => {
      console.log(city);
      UserInput("City", "", city);
      setcityTyped(city);
      await calcFormRef.setFieldsValue({ city: city });
      await FormStore.setCalcCity(city);
    };

    const handleEmailFocus = async () => {
      if (!FormStore.PiiMaskFlag) return;
      const value = calcFormRef.getFieldValue("emailItem");
      if (!value) return;
      try {
        await calcFormRef.validateFields(["emailItem"]);
        await FormStore.setCalcEmail("");
        await calcFormRef.setFieldsValue({
          emailItem: "",
        });
      } catch (err) {
        console.log("Email not valid, skipping clear");
      }
    };

    const handleEmailBlur = async (e) => {
      const value = e.target.value;
      if (!FormStore.PiiMaskFlag || !value) return;
      try {
        await calcFormRef.validateFields(["emailItem"]);
        await calcFormRef.setFieldsValue({
          emailItem: maskDetail(value),
        });
      } catch (err) {
        console.log("Email not valid, skipping mask");
      }
    };

    const removeMandatory = async () => {
      DataLayerFn(
        "SkipPersonalDetails_ClickHere||Calculator-Landing page|Skip Personal Details",
        FormStore,
        "",
        "",
        "",
        "",
      );
      await FormStore.setCalcClickTwo(false);
      calcFormRef.setFields([
        {
          name: "mobileItem",
          errors: [],
        },
      ]);
      calcFormRef.setFields([
        {
          name: "emailItem",
          errors: [],
        },
      ]);
    };

    const toggleCheckOne = async (e) => {
      var value = e.target.checked;
      if (value) {
        DataLayerFn(
          "ProductAssessment_T&CAccepted||Calculator-Landing page|ProductAssessment",
          FormStore,
          "",
          "",
          "",
          "",
        );
      } else {
        DataLayerFn(
          "ProductAssessment_T&CUnchecked||Calculator-Landing page|ProductAssessment",
          FormStore,
          "",
          "",
          "",
          "",
        );
      }
      // console.info("Check One :", value)
      FormStore.setCalcCheckOne(value);
      var yesNo = value ? "YES" : "NO";
      UserInput("TRAI_FLAG", "", yesNo);
    };

    const toggleCheckTwo = async (e) => {
      var value = e.target.checked;
      // console.info("Check Two :", value)
      FormStore.setCalcCheckTwo(value);
      checkTwoProcced(value);
      UserInput("suitCheckbox", "", value);
      if (value) {
        DataLayerFn(
          "SuitabilityAnalysis_Checked||Calculator-Landing page|SuitabilityAnalysis",
          FormStore,
          "",
          "",
          "",
          "",
        );
      } else {
        DataLayerFn(
          "SuitabilityAnalysis_UnChecked||Calculator-Landing page|SuitabilityAnalysis",
          FormStore,
          "",
          "",
          "",
          "",
        );
      }
    };

    const checkTwoProcced = (value) => {
      // proccedModalAction.setCalcCheckTwo(value)
    };

    const forceCheckTwo = async () => {
      DataLayerFn(
        "SuitabilityAnalysis_clicked||Calculator-Landing page|Suitability Analysis",
        FormStore,
        "",
        "",
        "",
        "",
      );

      FormStore.setCalcCheckTwo(true);
      FormStore.setSuitabilityModal(true);
      // document.body.style = "overflow: hidden;"
      // document.querySelectorAll("custom-suitablity-tag > .overlay")[0].style.removeProperty("height")
    };

    const focusErrorField = async (error) => {
      try {
        const containsMobileError = error.errorFields
          .map((item) => item.name[0])
          .includes("mobileItem");
        setMobileerrorMsg(containsMobileError ? true : false);
        var field = error["errorFields"][0]["name"][0];
        if (field === "ageItem") {
          dobInput.current.focus();
        } else if (field === "mobileItem") {
          mobInput.current.focus();
        } else if (field === "emailItem") {
          emailInput.current.focus();
        }
      } catch {}
      console.info("Error Valdiation :", error);
    };

    const handleClickOpen = async (values) => {
      console.log("values", values);
      var MAIN_URL = window.location.href;
      var URL_OBJ = new URL(MAIN_URL);
      var personaType = URL_OBJ.searchParams.get("persona");
      AppStore.setVisitedQuoteScreen(true);

      window.ReactOptionLead_Email = false;
      window.ReactOptionLead_Mobile = false;

      //qData in UserInput For Gamooga Events
      if (window.UserInput.qdata == "" || window.UserInput.qdata == undefined) {
        UserInput("qdata", "", GenerateQData(window.UserInput));
      }

      // NPS Toggle Check if updated on quote page then back
      if (!FormStore.persona_Validity) {
        if (FormStore.quote_NPS === "N") {
          var fieldValues = quoteFormRef.getFieldsValue(true);
          if (Object.entries(fieldValues).length > 0) {
            quoteFormRef.setFieldsValue({ Pension: "Me_&_Nominee" });
          }
          FormStore.setQuotePension("Me_&_Nominee");
          FormStore.setQuoteFormTab("1");
          UserInput("PensionFor", "", "wantMenominee");
          UserInput("calcType", "key", "GPPDA");
        }
      }

      var result = values;
      console.log(result);
      window.validate_fields.email_dataLayer = false;
      window.validate_fields.mobile_dataLayer = false;
      FormStore.setQuoteModal(true);
      if (!result.mobileItem && !result.emailItem) {
        DataLayerFn(
          "GetQuote_SkipPersonalDetails||Calculator-Landing page|Skip Personal Details",
          FormStore,
          "",
          "Calculate Pension",
          "",
          "",
        );
      } else if (!result.mobileItem && result.emailItem) {
        DataLayerFn(
          "GetQuote_EmailIDSubmitted||Calculator-Landing page|Email",
          FormStore,
          "",
          "Calculate Pension",
          "",
          "",
        );
        window.validate_fields.email_dataLayer = true;
        window.ReactOptionLead_Email = true;
      } else if (result.mobileItem && !result.emailItem) {
        DataLayerFn(
          "LeadSubmitted_MobileNumber||Calculator-Landing page|MobileNumber",
          FormStore,
          "",
          "Calculate Pension",
          "",
          "",
        );
        window.validate_fields.mobile_dataLayer = true;
        window.ReactOptionLead_Mobile = true;
      } else {
        DataLayerFn(
          "LeadSubmitted||Calculator-Landing page|Check Returns",
          FormStore,
          "",
          "Calculate Pension",
          "",
          "",
        );
        window.validate_fields.email_dataLayer = true;
        window.validate_fields.mobile_dataLayer = true;
        window.ReactOptionLead_Email = true;
        window.ReactOptionLead_Mobile = true;
      }

      FormStore.setQuoteScreen(true);
      if (FormStore.quote_modalLoader && typeof window.hj === "function") {
        window.hj =
          window.hj ||
          function () {
            (window.hj.q = window.hj.q || []).push(arguments);
          };
        if (personaType === "GPPDA") {
          //Roshan
          if (window.hj) {
            window.hj("stateChange", "gppda_qp");
            window.hj("event", "gppda_qp");
          }
        } else {
          if (window.hj) {
            window.hj("stateChange", "gppia_qp");
            window.hj("event", "gppia_qp");
          }
        }
        console.log("hotjar quote page");
      }

      await setTimeout(async () => {
        await QuoteAPI();
        // leadWSAPI(FormStore)
        try {
          //ExistingCustomer API Call to check existing customer and Fire Lead with youth_express tag
          ExistingCustomer();
        } catch {
          //Lead will fire even with API failure
          const leadRes = await leadWSAPI(FormStore);
        }
        const tracerAAPI = tracerAPI(FormStore, 1);
        ExistingCustToaster();

        setTimeout(async () => {
          const tracerBAPI = tracerAPI(FormStore, 2);
        }, 150);
        await FormStore.setQuoteModalLoader(false);
        DataLayerFn(
          "Quoteseen||Calculator-QuoteScreen|Quote Screen",
          FormStore,
          "",
          "",
          "",
          "",
        );
      }, 150);

      if (typeof window.$ !== "undefined") {
        var isCustomerEmpty =
          document.getElementsByTagName("existingcusthtml").length === 0;
        if (isCustomerEmpty) {
          setTimeout(() => {
            if (typeof window.existingCustToaster === "function") {
              window.existingCustToaster();
            }
          }, 250);
          setTimeout(() => {
            document.getElementsByClassName("ex-cust-toaster")[0].style.zIndex =
              1305;
            if (typeof window.loadCustomerReact === "function") {
              window.loadCustomerReact();
            }
          }, 2500);
        }
      }
    };
    console.log("FormStore.calc_type.key : ", toJS(FormStore.calc_type));
    return (
      <Card
        className="CalculatorCard"
        title={
          <div
            className="CalculatorTitle "
            dangerouslySetInnerHTML={{
              // __html: DOMPurify.sanitize(FormStore.quote_formTab == 0 ?  calculatorForm.sectionConfig.titleIA : calculatorForm.sectionConfig.title),
              __html: DOMPurify.sanitize(
                FormStore.calc_type.key == "GPPIA"
                  ? calculatorForm.sectionConfig.titleIA
                  : FormStore.calc_type.key == "GPPDA"
                    ? calculatorForm.sectionConfig.titleDA
                    : calculatorForm.sectionConfig.title,
              ),
            }}
          />
        }
      >
        <div
          className="CalculatorTitle"
          dangerouslySetInnerHTML={{
            // __html: DOMPurify.sanitize(FormStore.quote_formTab == 0 ? calculatorForm.sectionConfig.titleIA : calculatorForm.sectionConfig.title),
            __html: DOMPurify.sanitize(
              FormStore.calc_type.key == "GPPIA"
                ? calculatorForm.sectionConfig.titleIA
                : FormStore.calc_type.key == "GPPDA"
                  ? calculatorForm.sectionConfig.titleDA
                  : calculatorForm.sectionConfig.title,
            ),
          }}
        />
        <div className="CalculatorFormTitleParent">
          <div className="CalculatorFormTitle">
            <div className="guranteeIncomeCalc">Online Pension Calculator</div>
            <AI_Modal />
            <MobileModal />
            <Form
              layout={"vertical"}
              form={calcFormRef}
              onFinish={handleClickOpen}
              onFinishFailed={focusErrorField}
              initialValues={{
                calcNps: FormStore.quote_NPS,
                gender: FormStore.calc_gender,
                mobileItem: FormStore.calc_phone,
                maritalStatus: FormStore.calc_marital,
                ndncCheckbox: FormStore.calc_checkOne,
                suitCheckbox: FormStore.calc_checkTwo,
                // OneTimeInvestment: FormStore.quote_invest,
                investmentAmount: addCommas(FormStore.quote_invest),
                city: FormStore.calc_city,
                occupation: FormStore.occupation,
              }}
            >
              {new URL(window.location.href).searchParams.get("persona") !==
                "GPPDA" && (
                <div className="calcNps_head">
                  <RadioGroup
                    className="calcNps"
                    formName={"calcNps"}
                    styleName="radioBuyFor"
                    formClass={"CalculatorItem_calcNps"}
                    type={1}
                    dynamicTitle={""}
                    jsonData={calculatorForm["calcNps"]}
                    reverse={false}
                    onChange={toggleNps}
                  />
                </div>
              )}
              <RadioGroup
                className="gender"
                formName={"gender"}
                styleName="radioGender"
                formClass={"CalculatorItem_Gender"}
                type={1}
                dynamicTitle={
                  FormStore.calc_buyingFor === "self" ||
                  !FormStore.calc_buyingFor
                    ? ""
                    : `Your ${FormStore.calc_buyingFor}’s  Gender`
                }
                jsonData={calculatorForm["gender"]}
                reverse={true}
                onChange={toggleGender}
                condition={FormStore.calc_buyingFor !== "self" ? "Other" : ""}
                disableQ={disableQData}
              />
              {/* <span>{calculatorForm["OneTimeInvestment"].title}</span> */}

              {/* For dekstop it starts below*/}
              <div className="dekstopOnly">
                <div className="flexByRow">
                  <Form.Item
                    name="ageItem"
                    className={"CalculatorItem_DOB"}
                    validateFirst={true}
                    disabled={disableQData}
                    rules={[
                      {
                        required: true,
                        message: "*Please enter date of birth.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          var ageItem = getFieldValue("ageItem");
                          if (ageItem <= 0 || ageItem === undefined) {
                            return Promise.reject(
                              "*Please enter date of birth.",
                            );
                          } else if (FormStore.calc_age === -1) {
                            return Promise.reject("*Enter valid date of birth");
                          } else if (FormStore.calc_age === -2) {
                            var min = 30;
                            var max = 100;
                            return Promise.reject(
                              `This option is available only for age between ${min} to ${max} years.`,
                            );
                          } else {
                            UserInput("dob", "", ageItem);
                            UserInput("age", "", FormStore.calc_age);
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div className="dobIncomeTitle">
                        {FormStore.calc_buyingFor === "self" ||
                        !FormStore.calc_buyingFor
                          ? "Date of Birth"
                          : `Your ${FormStore.calc_buyingFor}’s  Date of Birth`}
                      </div>
                    }
                  >
                    <Input
                      disabled={disableQData}
                      id="DateTimeText"
                      className={`DOBField js-dobInput suitablity_DOB width190`}
                      type={"tel"}
                      ref={dobInput}
                      placeholder={"DD/MM/YYYY"}
                      onFocus={DateBoi}
                      onChange={inputWithMaskOnChange}
                      onPaste={inputWithMaskOnPaste}
                      suffix={
                        <span
                          className={`xxYears ${FormStore.calc_dob && Math.sign(FormStore.calc_age) === 1 ? "Show" : "Hide"} ${disableQData ? "qDisabled" : ""}`}
                        >
                          {(disableQData ? "XX" : FormStore.calc_age) +
                            " Years old"}
                        </span>
                      }
                    />
                  </Form.Item>
                  <RadioGroup
                    placeholder={"Select your marital status"}
                    formClass={"CalculatorItem_Marital"}
                    className={"dobIncomeTitle"}
                    styleName="radioAnnualIncome"
                    type={0}
                    dynamicTitle={""}
                    jsonData={calculatorForm["marital"]}
                    onChange={toggleMarital}
                    infoIcon={false}
                    formName={"maritalStatus"}
                    validate={true}
                    onToolTipClick={null}
                    validateMesssage={"*Select marital status"}
                    // disableQ={disableQData}
                  />
                </div>
              </div>

              {/* For dekstop it  ends above */}

              {/* For Mobile  it starts below  */}
              <div className="mobileOnly">
                <div className="flexByColumn">
                  <Form.Item
                    name="ageItem"
                    className={"CalculatorItem_DOB"}
                    validateFirst={true}
                    disabled={disableQData}
                    rules={[
                      {
                        required: true,
                        message: "*Please enter date of birth.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          var ageItem = getFieldValue("ageItem");
                          if (ageItem <= 0 || ageItem === undefined) {
                            return Promise.reject(
                              "*Please enter date of birth.",
                            );
                          } else if (FormStore.calc_age === -1) {
                            return Promise.reject("*Enter valid date of birth");
                          } else if (FormStore.calc_age === -2) {
                            var min = 30;
                            var max = 100;
                            return Promise.reject(
                              `This option is available only for age between ${min} to ${max} years.`,
                            );
                          } else {
                            UserInput("dob", "", ageItem);
                            UserInput("age", "", FormStore.calc_age);
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div className="dobIncomeTitle">
                        {FormStore.calc_buyingFor === "self" ||
                        !FormStore.calc_buyingFor
                          ? "Date of Birth"
                          : `Your ${FormStore.calc_buyingFor}’s  Date of Birth`}
                      </div>
                    }
                  >
                    <Input
                      disabled={disableQData}
                      id="DateTimeText"
                      className={`DOBField js-dobInput suitablity_DOB`}
                      type={"tel"}
                      ref={dobInput}
                      placeholder={"DD/MM/YYYY"}
                      onFocus={DateBoi}
                      onChange={inputWithMaskOnChange}
                      onPaste={inputWithMaskOnPaste}
                      suffix={
                        <span
                          className={`xxYears ${FormStore.calc_dob && Math.sign(FormStore.calc_age) === 1 ? "Show" : "Hide"} ${disableQData ? "qDisabled" : ""}`}
                        >
                          {(disableQData ? "XX" : FormStore.calc_age) +
                            " Years old"}
                        </span>
                      }
                    />
                  </Form.Item>
                  <RadioGroup
                    placeholder={"Select your marital status"}
                    formClass={"CalculatorItem_Marital"}
                    className={"dobIncomeTitle"}
                    styleName="radioAnnualIncome"
                    type={1}
                    dynamicTitle={""}
                    jsonData={calculatorForm["marital"]}
                    onChange={toggleMarital}
                    infoIcon={false}
                    formName={"maritalStatus"}
                    validate={true}
                    onToolTipClick={null}
                    validateMesssage={"*Select marital status"}
                    // disableQ={disableQData}
                  />
                </div>
              </div>

              {/* For Mobile  it ends above  */}

              <div className="dekstopOnly">
                <div className={"flexByRow"}>
                  <Form.Item
                    name="mobileItem"
                    className={"CalculatorItem_Mobile"}
                    validateFirst={true}
                    extra={
                      moberrorMsg === false ? (
                        <span className="spamMsg">
                          Don’t worry. We won't Spam!
                        </span>
                      ) : null
                    }
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "*Enter 10 digit mobile number",
                      },
                      ({ getFieldValue }) => ({
                        async validator(_, value) {
                          var mobileItem = getFieldValue("mobileItem");
                          if (mobileItem && !disableQData) {
                            const isMasked =
                              mobileItem && mobileItem.includes("X");
                            // Skip validation for masked prefilled numbers
                            if (isMasked && FormStore.PiiMaskFlag) {
                              return Promise.resolve();
                            }
                            const mobile = await phoneValidation(mobileItem);
                            console.info("Mobile Item :", mobileItem, mobile);
                            if (!mobile.valid && !disableQData) {
                              setMobileerrorMsg(true);
                              return Promise.reject(
                                "Enter 10 digit mobile number",
                              );
                            } else {
                              setMobileerrorMsg(false);
                              return Promise.resolve();
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div
                        className="mobileEmailTitle"
                        onMouseEnter={() => mobInput.current.blur()}
                      >
                        {FormStore.calc_buyingFor === "self" ||
                        !FormStore.calc_buyingFor
                          ? "Mobile Number"
                          : `Your Mobile Number`}
                        <span
                          onClick={
                            AppStore.device === 0 ? toggleMobileToolTip : null
                          }
                        >
                          <IconTooltip
                            title={
                              "Existing customers please put your existing mobile no. & get waiver of docs & short-application if applicable"
                            }
                            zIndex={null}
                          />
                        </span>
                      </div>
                    }
                  >
                    <Input
                      disabled={disableQData}
                      ref={mobInput}
                      id="E11_mobile"
                      placeholder="10 digit mobile number"
                      className={`js-mobileNo suitablity_mobilenumber leadmob ${AppStore.device === 1 && "width190"}`}
                      type={"tel"}
                      value={FormStore.calc_phone}
                      maxLength={10}
                      onChange={phoneNumberInput}
                      onFocus={handleMobileFocus}
                      onBlur={handleMobileBlur}
                    />
                  </Form.Item>
                  <Form.Item
                    name="emailItem"
                    className={"CalculatorItem_Email"}
                    validateFirst={true}
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "*Enter valid email id",
                      },
                      ({ getFieldValue }) => ({
                        async validator(_, value) {
                          var emailItem = getFieldValue("emailItem");
                          if (emailItem) {
                            const email = await emailValidation(emailItem);
                            if (email.valid) {
                              FormStore.setCalcEmail(email.email);
                              UserInput("EmailId", "", email.email);
                              return Promise.resolve();
                            } else {
                              return Promise.reject("Enter valid email id");
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div className="mobileEmailTitle">
                        {FormStore.calc_buyingFor === "self" ||
                        !FormStore.calc_buyingFor
                          ? "Email"
                          : `Your Email`}
                      </div>
                    }
                  >
                    <Input
                      disabled={disableQData}
                      ref={emailInput}
                      id="E11_emailId"
                      placeholder="Enter Your Email Id"
                      className={`js-emaiId suitablity_emailid leademail width190`}
                      onChange={onChangeEmailInput}
                      onFocus={handleEmailFocus}
                      onBlur={handleEmailBlur}
                    />
                  </Form.Item>
                </div>
              </div>

              {/* For Mobile  it starts below  */}
              <div className="mobileOnly">
                <div className={"flexByColumn"}>
                  <Form.Item
                    name="mobileItem"
                    className={"CalculatorItem_Mobile"}
                    validateFirst={true}
                    extra={
                      moberrorMsg === false ? (
                        <span className="spamMsg">
                          Don’t worry. We won't Spam!
                        </span>
                      ) : null
                    }
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "*Enter 10 digit mobile number",
                      },
                      ({ getFieldValue }) => ({
                        async validator(_, value) {
                          var mobileItem = getFieldValue("mobileItem");
                          if (mobileItem && !disableQData) {
                            const isMasked =
                              mobileItem && mobileItem.includes("X");
                            // Skip validation for masked prefilled numbers
                            if (isMasked && FormStore.PiiMaskFlag) {
                              return Promise.resolve();
                            }
                            const mobile = await phoneValidation(mobileItem);
                            console.info("Mobile Item :", mobileItem, mobile);
                            if (!mobile.valid && !disableQData) {
                              setMobileerrorMsg(true);
                              return Promise.reject(
                                "Enter 10 digit mobile number",
                              );
                            } else {
                              setMobileerrorMsg(false);
                              return Promise.resolve();
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div
                        className="mobileEmailTitle"
                        onMouseEnter={() => mobInput.current.blur()}
                      >
                        {FormStore.calc_buyingFor === "self" ||
                        !FormStore.calc_buyingFor
                          ? "Mobile Number"
                          : `Your Mobile Number`}
                        <span
                          onClick={
                            AppStore.device === 0 ? toggleMobileToolTip : null
                          }
                        >
                          <IconTooltip
                            title={
                              "Existing customers please put your existing mobile no. & get waiver of docs & short-application if applicable"
                            }
                            zIndex={null}
                          />
                        </span>
                      </div>
                    }
                  >
                    <Input
                      disabled={disableQData}
                      ref={mobInput}
                      id="E11_mobile"
                      placeholder="10 digit mobile number"
                      className={`js-mobileNo suitablity_mobilenumber leadmob`}
                      type={"tel"}
                      value={FormStore.calc_phone}
                      maxLength={10}
                      onChange={phoneNumberInput}
                      onFocus={handleMobileFocus}
                      onBlur={handleMobileBlur}
                    />
                  </Form.Item>
                  <Form.Item
                    name="emailItem"
                    className={"CalculatorItem_Email"}
                    validateFirst={true}
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "*Enter valid email id",
                      },
                      ({ getFieldValue }) => ({
                        async validator(_, value) {
                          var emailItem = getFieldValue("emailItem");
                          if (emailItem) {
                            const email = await emailValidation(emailItem);
                            if (email.valid) {
                              FormStore.setCalcEmail(email.email);
                              UserInput("EmailId", "", email.email);
                              return Promise.resolve();
                            } else {
                              return Promise.reject("Enter valid email id");
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div className="mobileEmailTitle">
                        {FormStore.calc_buyingFor === "self" ||
                        !FormStore.calc_buyingFor
                          ? "Email"
                          : `Your Email`}
                      </div>
                    }
                  >
                    <Input
                      disabled={disableQData}
                      ref={emailInput}
                      id="E11_emailId"
                      placeholder="Enter Your Email Id"
                      className={`js-emaiId suitablity_emailid leademail`}
                      onChange={onChangeEmailInput}
                      onFocus={handleEmailFocus}
                      onBlur={handleEmailBlur}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="dekstopOnly">
                <div className={"flexByRow"} style={{ paddingBottom: "20px" }}>
                  <RadioGroup
                    placeholder={"Select Occupation"}
                    formClass={"CalculatorItem_Marital"}
                    className={"dobIncomeTitle"}
                    styleName="radioAnnualIncome"
                    type={0}
                    dynamicTitle={""}
                    jsonData={removeOptions(calculatorForm["occupation"])}
                    onChange={toggleOccupation}
                    infoIcon={false}
                    formName={"occupation"}
                    validate={true}
                    onToolTipClick={null}
                    validateMesssage={"*Select marital status"}
                    // disableQ={disableQData}
                  />
                  <Form.Item
                    name="city"
                    className={"CalculatorItem_City"}
                    validateFirst={true}
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "Enter City",
                      },
                      ({ getFieldValue }) => ({
                        async validator(_, value) {
                          var cityIten = getFieldValue("city");
                          console.log("cityIten", cityIten);
                          if (cityIten) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject("Please enter city name");
                          }
                        },
                      }),
                    ]}
                    label={<div className="mobileEmailTitle">Enter City</div>}
                    onMouseLeave={() => {
                      setShowCityOptions(false);
                    }}
                  >
                    <Input
                      disabled={disableQData}
                      ref={cityInput}
                      id="lead_city"
                      placeholder="Enter City"
                      className={`js-city width190`}
                      onChange={onChangeCityInput}
                      onFocus={() => setShowCityOptions(true)}
                      suffix={
                        <span className="cityDropdownIcon">
                          <img src={Dropdown_Icon} />
                        </span>
                      }
                      value={cityTyped}
                    />
                    <div
                      className={"cityOptionClass"}
                      style={{
                        display: showCityOptions ? "flex" : "none",
                        zIndex: showCityOptions ? 100000 : 1,
                      }}
                    >
                      {filteredCity.map((data, index) => {
                        if (data === "divider") {
                          if (cityTyped === "")
                            return (
                              <div
                                style={{
                                  width: "96%",
                                  borderTop: "1px solid lightgrey",
                                  margin: "0px auto",
                                }}
                              ></div>
                            );
                          else return "";
                        } else {
                          return (
                            <p
                              key={index}
                              onClick={() => {
                                setShowCityOptions((prev) => !prev);
                                citySelected(data);
                              }}
                              className={
                                FormStore.calc_city === data
                                  ? "selectedValue"
                                  : ""
                              }
                            >
                              {data}
                            </p>
                          );
                        }
                      })}
                    </div>
                  </Form.Item>
                </div>
              </div>

              <div className="mobileOnly">
                <div
                  className={"flexByColumn"}
                  style={{ paddingBottom: "20px" }}
                >
                  <RadioGroup
                    placeholder={"Select Occupation"}
                    formClass={"CalculatorItem_Marital"}
                    className={"dobIncomeTitle"}
                    styleName="radioAnnualIncome"
                    type={0}
                    dynamicTitle={""}
                    jsonData={removeOptions(calculatorForm["occupation"])}
                    onChange={toggleOccupation}
                    infoIcon={false}
                    formName={"occupation"}
                    validate={true}
                    onToolTipClick={null}
                    validateMesssage={"*Select marital status"}
                    // disableQ={disableQData}
                  />
                  <Form.Item
                    name="city"
                    className={"CalculatorItem_City"}
                    validateFirst={true}
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "Enter City",
                      },
                      ({ getFieldValue }) => ({
                        async validator(_, value) {
                          var cityIten = getFieldValue("city");
                          if (cityIten) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject("Please enter city name");
                          }
                        },
                      }),
                    ]}
                    label={<div className="mobileEmailTitle">Enter City</div>}
                    onMouseLeave={() => {
                      setShowCityOptions(false);
                    }}
                  >
                    <Input
                      disabled={disableQData}
                      ref={cityInput}
                      id="lead_city"
                      placeholder="Enter City"
                      className={`js-city`}
                      onChange={onChangeCityInput}
                      onFocus={() => setShowCityOptions(true)}
                      suffix={
                        <span className="cityDropdownIcon">
                          <img src={Dropdown_Icon} />
                        </span>
                      }
                      value={cityTyped}
                    />
                    <div
                      className={"cityOptionClass"}
                      style={{
                        display: showCityOptions ? "flex" : "none",
                        zIndex: showCityOptions ? 100000 : 1,
                      }}
                    >
                      {filteredCity.map((data, index) => {
                        if (data === "divider") {
                          if (cityTyped === "")
                            return (
                              <div
                                style={{
                                  width: "96%",
                                  borderTop: "1px solid lightgrey",
                                  margin: "0px auto",
                                }}
                              ></div>
                            );
                          else return "";
                        } else {
                          return (
                            <p
                              key={index}
                              onClick={() => {
                                setShowCityOptions((prev) => !prev);
                                citySelected(data);
                              }}
                              className={
                                FormStore.calc_city === data
                                  ? "selectedValue"
                                  : ""
                              }
                            >
                              {data}
                            </p>
                          );
                        }
                      })}
                    </div>
                  </Form.Item>
                </div>
              </div>
              {/* For Mobile  it ends above  */}
              <div className="CheckboxGroup">
                <Form.Item
                  name="ndncCheckbox"
                  className="flexByRow columnGap5 CalculatorItem_CheckOne"
                >
                  <Checkbox onChange={toggleCheckOne} defaultChecked={true} />
                </Form.Item>
                <span className="checkboxLabel">
                  {viewMore ? NDNC_DISCLAIMER_TRUNCATED : NDNC_DISCLAIMER_FULL}{" "}
                  <a
                    className="checkboxLabel formCheckClick2"
                    onClick={toggleViewMore}
                  >
                    {viewMore ? "View More" : "View Less"}
                  </a>
                  <br />
                  {FormStore.calc_clickTwo && (
                    <span>
                      <br />
                      {
                        "If you wish to be redirected to calculate your premium without sharing your personal details, "
                      }
                      <a
                        className="checkboxLabel formCheckClick2"
                        onClick={removeMandatory}
                      >
                        click here
                      </a>
                      .
                    </span>
                  )}
                </span>
              </div>

              {/* {!FormStore.suitabilityFlag && (
              <div className="CheckboxGroup">
                <Form.Item
                  name="suitCheckbox"
                  className="flexByRow columnGap5 CalculatorItem_CheckTwo"
                >
                  <Checkbox
                    onChange={toggleCheckTwo}
                    checked={FormStore.calc_checkTwo}
                  />
                </Form.Item>
                <span className="checkboxLabel">
                  {"To undergo suitability analysis, please "}
                  <a
                    className="checkboxLabel formCheckClick1 "
                    onClick={forceCheckTwo}
                  >
                    click here
                  </a>
                  . <br />
                  {
                    "By not undergoing the suitability analysis, you confirm to purchase the policy based on your independent assessment of the suitability of the product."
                  }
                  {FormStore.calc_clickTwo && (
                    <span>
                      <br />
                      {
                        "If you wish to be redirected to calculate your premium without sharing your personal details, "
                      }
                      <a
                        className="checkboxLabel formCheckClick2"
                        onClick={removeMandatory}
                      >
                        click here
                      </a>
                      .
                    </span>
                  )}
                </span>
              </div>
            )} */}
              <GenericButton
                title={"Calculate Pension"}
                className="calculateFormDiv"
              />
            </Form>
            <form id="SavingSurakshaJsonForm" method="POST">
              <input type="hidden" name="bolData" id="bolData" value="" />
            </form>
          </div>
        </div>
      </Card>
    );
  },
);

export default Calculator;
